import React, { useEffect } from "react";
import {
  Modal,
  Box,
  Fade,
  Typography,
  Button,
  IconButton,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

import authService from "../../../../../services/AuthService.js";
import "./Item.scss";
import { useState } from "react";

export function Item({ item, setSelectedItem }) {
  const { t, i18n } = useTranslation("main");

  const {
    title,
    category,
    description_long_html,
    description_short,
    url,
    color_bg_1,
    color_txt_1,
    bg_image_uuid,
    tags,
    aoi,
  } = item || {};
  // console.log("Item url", url);

  const open = item !== undefined;

  const [imageError, setImageError] = useState(false);

  const handleClose = () => {
    setSelectedItem(undefined);
  };

  const parsedUrl = url ? new URL(url) : null;
  const baseUrl = parsedUrl ? `${parsedUrl.origin}` : "";
  const redirectPath = parsedUrl
    ? `${baseUrl}/token/${authService.getToken()}/redirect?url=${encodeURIComponent(
        parsedUrl.pathname + parsedUrl.search
      )}`
    : "#";

  // console.log("imageErrorimageError", imageError);

  useEffect(() => {
    setImageError(false);
  }, [item]);

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <Box
          sx={{
            maxHeight: "90dvh",
            width: "80vw",
            maxWidth: "800px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            borderRadius: "2rem",
            overflow: "hidden",
            border: "none",
          }}
        >
          <IconButton
            style={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
              backgroundColor: "#030303aa",
              borderRadius: "1rem",
              color: "white",
              zIndex: "1",
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>

          {/* Imagen */}
          {!imageError && (
            <div
              style={{
                width: "100%",
                overflow: "hidden",
              }}
            >
              <img
                src={
                  bg_image_uuid?.url || `/images/pocs_images/${title?.en}.png`
                }
                onError={() => setImageError(true)}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                }}
              />
            </div>
          )}

          {/* Descripción */}
          <div
            style={{
              backgroundColor: "rgba(3,3,3,0.9)",
              display: "flex",
              flexDirection: "column",
              maxHeight: "60vh",
            }}
          >
            <div
              style={{
                padding: "2rem",
                overflowY: "auto",
              }}
            >
              {description_long_html?.[i18n.language] ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: description_long_html[i18n.language],
                  }}
                />
              ) : (
                <Typography variant="body1">
                  {description_short?.[i18n.language]}
                </Typography>
              )}
            </div>

            {url && (
              <div className="visit-footer-container">
                {(tags?.length > 0 || aoi !== undefined) && (
                  <div
                    style={{
                      margin: "1rem",
                      gap: "1rem",
                      display: "flex",
                    }}
                  >
                    {tags?.length > 0 && (
                      <div>
                        <Typography>{t("tags")}</Typography>
                        {tags?.map((tag) => (
                          <Chip
                            variant="contained"
                            color="error"
                            label={`# ${tag.tag[i18n.language]}`}
                          />
                        ))}
                      </div>
                    )}
                    {aoi !== undefined && (
                      <div>
                        <Typography>{t("aois")}</Typography>
                        <Chip
                          variant="outlined"
                          color="primary"
                          label={`@ ${aoi.name[i18n.language]}`}
                        />
                      </div>
                    )}
                  </div>
                )}

                <a
                  style={{
                    color: "var(--color-primary-txt)",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  target="_blank"
                  // href={url}
                  href={redirectPath}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      margin: "1rem",
                      minWidth: "10rem",
                      backgroundColor: color_bg_1 + "cc",
                      color: color_txt_1,
                      borderRadius: "1rem",
                    }}
                  >
                    {t("visit")}
                  </Button>
                </a>
              </div>
            )}
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
